module.exports = __webpack_public_path__ + "img/registerlogin_5.a388ac1a.jpg";